import { render } from "./Party.vue?vue&type=template&id=474ff0d3"
import script from "./Party.vue?vue&type=script&lang=js"
export * from "./Party.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__